import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { PropertyListRequestBody, PropertyListResponse } from "./types";

export class PropertyListAPI extends BaseAPI<
    PropertyListRequestBody,
    PropertyListResponse
> {
    protected route = ApiRoutes.property.list;
    protected method = RequestMethod.GET;
    protected params = ["page", "page_size", "search", "status", "type", "is_hot"];
}
